module.exports = __webpack_public_path__ + "img/logo-8.27f137d8.png";